import { find, get } from 'lodash'

import { filterArray, removeEmptyStrings } from '@/pages/OrganizationUserEditPage/UserAccountView/utils'

const getFirstPrimaryIndex = (field: any) => {
  if (!field) return -1
  const primary = field.reduce((acc: any, f: any, index: any) => (acc === -1 && f.primary ? index : acc), -1)
  return primary
}

export const mapSubmitValues = (values: any, orgId: any, attributes: any[] = [], orgAdminRoleId: any) => {
  const mappedValues: Record<string, any> = {
    ...removeEmptyStrings(values),
    addresses: filterArray(values.addresses, getFirstPrimaryIndex(values.addresses)),
    emails: filterArray(values.emails, getFirstPrimaryIndex(values.emails)),
    name: { ...removeEmptyStrings(values.name) },
    phoneNumbers: filterArray(values.phoneNumbers, getFirstPrimaryIndex(values.phoneNumbers)),
    photos: filterArray(values.photos, getFirstPrimaryIndex(values.photos)),
    'urn:ietf:params:scim:schemas:extension:enterprise:2.0:User': {
      ...removeEmptyStrings(values.enterpriseUser)
    },
    organizationRoleId: values.isOrgAdmin === 'true' ? orgAdminRoleId : null
  }

  mappedValues[`urn:ietf:params:scim:schemas:extension:workgrid:2.0:${orgId}`] =
    Object.keys(values.customAttributes).length > 0
      ? Object.keys(values.customAttributes).reduce(
          (obj, scimAttributeName) => {
            if (values.customAttributes[scimAttributeName] !== '') {
              const type = get(find(attributes, { scimAttributeName }), 'type')
              switch (type) {
                case 'binary':
                case 'string':
                case 'datetime': {
                  obj[scimAttributeName] = values.customAttributes[scimAttributeName]
                  break
                }
                case 'decimal':
                case 'integer': {
                  obj[scimAttributeName] = Number.parseFloat(values.customAttributes[scimAttributeName])
                  break
                }
                case 'boolean': {
                  obj[scimAttributeName] = values.customAttributes[scimAttributeName] === 'true'
                  break
                }
                default: {
                  break
                }
              }
            }
            return obj
          },
          {} as Record<string, any>
        )
      : null

  delete mappedValues.customAttributes
  delete mappedValues.enterpriseUser
  delete mappedValues.isOrgAdmin
  delete mappedValues.primaryAddress
  delete mappedValues.primaryEmail
  delete mappedValues.primaryPhone
  delete mappedValues.primaryPhoto

  return mappedValues
}
